import { DRAWER_WIDTH } from '@toggle/design-system';
import { borderRadius } from '@toggle/design-system';
import styled from 'styled-components';

const DRAWER_HEADER_HEIGHT = 40;
const GAP_FROM_DRAWER = 20;

export const ToastPositioner = styled.div`
  position: fixed;
  right: ${DRAWER_WIDTH + GAP_FROM_DRAWER}px;
  top: ${DRAWER_HEADER_HEIGHT}px;
  z-index: var(--z-index-modal);
`;

export const ToastRoot = styled.div`
  width: 436px;
  background-color: var(--surface-default);
  ${borderRadius.r2};
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
